/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryModule
 * Purpose		: Module for OrdersQry.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { OrdersQryService } from './OrdersQry.service';
import { OrdersQryListComponent } from './OrdersQryList.component';
import { OrdersQrySearchComponent } from './OrdersQrySearch.component';
import { OrdersQryDetailsComponent } from './OrdersQryDetails.component';

import { OrdersQryRoutingModule } from './OrdersQry-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    OrdersQryRoutingModule
  ],
  declarations: [
    OrdersQryListComponent,
	OrdersQrySearchComponent,
	OrdersQryDetailsComponent
  ],
  providers: [
    OrdersQryService
  ]
})

export class OrdersQryModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrdersQry/OrdersQry.module.ts